import React from 'react';

import { FullScreenAlert } from 'components/FullScreenAlert';
import { useTranslation } from 'react-i18next';

export function WhiteLabelForbiddenAlert() {
  const { t } = useTranslation();

  return <FullScreenAlert header={t('APP.WHITE_LABEL_ACCESS.TITLE')} body={t('APP.WHITE_LABEL_ACCESS.MESSAGE')} />;
}
